import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../lib/queryKeys';
import { syncReplyThread } from '../api/inbox';
import { useToast } from '../contexts/ToastContext.jsx';

export function useSyncReplyThread () {
  const qc = useQueryClient();
  const { addToast } = useToast();
  return useMutation({
    mutationFn: (leadId) => syncReplyThread(leadId),
    onSuccess: (data, leadId) => {
      qc.invalidateQueries({ queryKey: queryKeys.messages.byLead(leadId) });
      qc.invalidateQueries({ queryKey: queryKeys.inbox.all });
      if (data?.linked === false) addToast('Лид не в Reply', 'Нет связанного контакта Reply.io', 'error');
      // C6/F1: skipped=true → Reply не вернул сообщений, перестройка НЕ выполнялась.
      // Это не успешное обновление — зелёный тост врал бы.
      else if (data?.skipped) addToast('Тред не обновлён', 'Reply.io не вернул сообщений — прежняя история сохранена', 'warning');
      else addToast('Тред обновлён', `Сообщений: ${data?.rebuilt ?? 0}`, 'success');
    },
    onError: (err) => {
      if (err?.status === 429) {
        const s = Math.ceil((err?.data?.retryAfterMs ?? 45000) / 1000);
        addToast('Подождите', `Обновление доступно через ~${s} с`, 'error');
      } else {
        addToast('Ошибка', err?.data?.error || 'Не удалось обновить тред', 'error');
      }
    },
  });
}
